import api from './api';

class WorkbenchService {
  async getWorkbench(sessionId: string): Promise<{ content: string; updatedAt: string | null }> {
    const { data } = await api.get(`/sessions/${sessionId}/workbench`);
    return data;
  }

  async updateWorkbench(sessionId: string, content: string): Promise<{ content: string; updatedAt: string }> {
    const { data } = await api.put(`/sessions/${sessionId}/workbench`, { content });
    return data;
  }
}

export const workbenchService = new WorkbenchService();
